import Vue from 'vue'
import App from './App.vue'

import router from './router'
import { BootstrapVue} from 'bootstrap-vue'
import i18n from '@/locale/i18n'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)

Vue.config.productionTip = false

new Vue({
    el: '#app',
    name: 'Main',
    router,
    i18n,
    render: h => h(App)
}).$mount('#app')
